import {
    Button,
    CircularProgress,
    FormControlLabel,
    InputAdornment,
    MenuItem,
    Radio,
    RadioGroup,
    TextField,
} from "@mui/material";
import { Field, Form, Formik } from "formik";
import { useContext, useEffect, useRef, useState } from "react";
import DocumentTable from "../../../components/OB/BelgeYukleme";
import BasvuruTuruAPI from "../../../apis/OB/Get/BasvuruTuruAPI";
import BilgilendirmePopup from "../../../components/OB/popups/BilgilendirmePopUp";
import AciklamaAndUserControlPopup from "../../../components/OB/popups/aciklama-usercontrol-popup";
import CustomTextField from "../../../components/OB/required-text-field";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import Recaptcha from "../../../components/Recaptcha";
import * as Yup from "yup";
import SessionStorageService from "../../../services/StorageService";
import { MuiTelInput } from "mui-tel-input";
import YardimTuruSearchAPI, { YardimTuruSearchRequest } from "../../../apis/OB/Get/YardimTuruSearchAPI";
import kullaniciAdresGetAPI from "../../../apis/KullaniciYonetimi";

const validationSchema = Yup.object({
    yardimTuru: Yup.number().required("Yardım türü zorunludur"),
    aciklama: Yup.string().required("Açıklama zorunludur"),
});

const SosyalYardimBasvurusu = (props: any) => {

    const [userControlPopup, setUserControlPopup] = useState(false);
    const user = SessionStorageService.getUserInfo();

    const [isLoad, setIsLoad] = useState(true);
    const navigate = useNavigate();

    // yardım türleri listeleme
    const [yardimTurleri, setYardimTurleri] = useState<YardimTuruOption[]>([]);
    // yardım türü seçme
    const [selectedYardimTuru, setSelectedYardimTuru] = useState<number | null>(null);

    const [adres, setAdres] = useState<string>('');

    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [popupbasvuruMetni, setPopupbasvuruMetni] = useState("");
    const [kayitBasarili, setKayitBasarili] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState<string>('');

    const closePopupSonuc = () => {
        setIsPopupVisible(false);
        setPopupbasvuruMetni("");
    };

    const initialRows = [
        { id: 1, documentName: "Belge 1", isRequired: true },
        { id: 2, documentName: "Belge 2", isRequired: false },
    ];
    const [documents, setDocuments] = useState(initialRows);

    const handleUpdateDocuments = (updatedDocuments: any) => {
        setDocuments(updatedDocuments);
    };

    interface YardimTuruOption {
        yardimTuruKodu: number;
        yardimTuruAdi: string;
    }

    useEffect(() => {
        if (user == null) {
            setUserControlPopup(true);
        } else {
            setIsLoad(false);
        }

    }, []);

    const closeUserControlPopup = () => {
        setUserControlPopup(false);
        navigate(-1);
    }

    // yardım türü
    useEffect(() => {
        (async () => {
            setIsLoading(true);
            try {
                const response = await YardimTuruSearchAPI.yardimTuruSearch(new YardimTuruSearchRequest());
                const rawList = response.data ?? [];
                const list = rawList.map((o: any) => ({
                    yardimTuruKodu: o.yardimturuKodu,
                    yardimTuruAdi: o["yardımTuruAdi"] ?? o.aciklama ?? ""
                }));
                setYardimTurleri(list);
            } catch (err) {
                console.error(err);
                setMessage("Yardım türleri alınırken hata oluştu.");
                setYardimTurleri([]);
            } finally {
                setIsLoading(false);
            }
        })();
    }, []);

    // adres
    useEffect(() => {
        const fetchAdres = async () => {
            try {
                const response = await kullaniciAdresGetAPI.kullaniciAdresGet({ kullaniciId: user.sqId });
                //console.log("response: ", response);
                const adresList = response.data ?? [];

                if (adresList.length > 0) {
                    const item = adresList[0];
                    const fullAddress = `${item.mahalleAdi ?? ''} Mah. ${item.caddeAdi ?? ''} Cad. ${item.siteApartmanAdi ?? ''} Blok No: ${item.kapiNo ?? ''}/${item.daireNo ?? ''} ${item.ilIlceAdi ?? ''}`;
                    setAdres(fullAddress.trim());
                }

            } catch (error) {
                console.error("Adres alınamadı", error);
            }
        };

        fetchAdres();
    }, []);


    return (
        isLoad ? <>
            <div className="d-flex align-self-strech justify-content-center align-items-center"> <CircularProgress /></div>
            {userControlPopup ? (

                <AciklamaAndUserControlPopup
                    open={userControlPopup}
                    handleClose={closeUserControlPopup}
                    isUserControlPopUp={true}
                    description={"Bu sayfayı kullanmak için giriş yapmalısınız."}
                />

            ) : null}
        </> :
            <Formik
                enableReinitialize
                validationSchema={validationSchema}
                validateOnMount={true}
                initialValues={{
                    basvuruTuruId: 9,
                    yardimTuru: null,
                    cepTelefonu: '',
                    ikametgahAdresi: adres,
                    aciklama: '',
                }}
                onSubmit={async (values: any, { resetForm }) => {

                    const transformedValues = {
                    };

                    // api çağırılacak

                }}
            >

                {(formikProps) => {

                    return (
                        <Form>
                            <div className="mb-3 d-flex justify-content-end">
                                <Button
                                    type="button"
                                    onClick={() =>
                                        formikProps.resetForm({ values: formikProps.initialValues })
                                    }
                                    color="secondary"
                                >
                                    Temizle
                                </Button>
                            </div>

                            <div className="card shadow-none border w-100 mb-4">
                                <div className="bg-white px-3 py-1 small fw-semibold">
                                    SOSYAL YARDIM BAŞVURUSU
                                </div>
                                <div className="card-body">

                                    <div className="row g-3 mb-3">
                                        <div className="col-12 col-md-6 d-flex flex-column">
                                            <div style={{ fontSize: "0.85rem", color: "#6c757d", marginBottom: "4px" }}>
                                                Lütfen aşağıdaki seçeneklerden başvurmak istediğiniz yardım türünü seçiniz.
                                            </div>
                                            <CustomTextField
                                                name="yardimTuru"
                                                fullWidth
                                                select
                                                label="Yardım Türü *"
                                                size="small"
                                                error={
                                                    formikProps.errors.yardimTuru &&
                                                        formikProps.touched.yardimTuru
                                                        ? true
                                                        : false
                                                }
                                                value={formikProps.values.yardimTuru}
                                                onChange={(e: any) => {
                                                    const val = Number(e.target.value);
                                                    formikProps.setFieldValue("yardimTuru", val);
                                                    setSelectedYardimTuru(val);
                                                }}

                                            >
                                                <MenuItem selected value={null as any}>
                                                    {"Seçiniz.."}
                                                </MenuItem>
                                                {yardimTurleri.map((option) => (
                                                    <MenuItem
                                                        key={option.yardimTuruKodu}
                                                        value={option.yardimTuruKodu}
                                                    >
                                                        {option.yardimTuruAdi}
                                                    </MenuItem>
                                                ))}
                                            </CustomTextField>
                                        </div>
                                        <div className="col-12 col-md-6 d-flex flex-column">
                                            <div style={{ visibility: "hidden", fontSize: "0.85rem", marginBottom: "4px" }}>
                                                Placeholder
                                            </div>
                                            <MuiTelInput
                                                name="cepTelefonu"
                                                fullWidth
                                                defaultCountry="TR"
                                                onlyCountries={["TR"]}
                                                className="mb-3"
                                                size="small"
                                                label="Cep Telefonu"
                                                error={
                                                    (formikProps.errors.cepTelefonu &&
                                                        formikProps.touched.cepTelefonu)
                                                        ? true
                                                        : false
                                                }
                                                value={formikProps.values.cepTelefonu}
                                                inputProps={{ maxLength: 17 }}
                                                onChange={(value: any) => {
                                                    // +90 ön ekini koruyacak şekilde değeri ayarlıyoruz
                                                    const prefix = "+90 ";
                                                    if (!value.startsWith(prefix)) {
                                                        value = prefix + value.replace(/^\+90/, "");
                                                    }
                                                    formikProps.setFieldValue("cepTelefonu", value);
                                                }}
                                                variant="outlined"
                                            />
                                        </div>
                                    </div>
                                    <div className="row g-3 mb-3 align-items-stretch">
                                        <div className="col-12 col-md-6 d-flex flex-column">
                                            <div style={{ visibility: "hidden", fontSize: "0.85rem", marginBottom: "4px" }}>
                                                Placeholder
                                            </div>
                                            <TextField
                                                label="İkametgah Adresiniz"
                                                fullWidth
                                                multiline
                                                rows={5}
                                                size="small"
                                                InputProps={{ style: { height: "100%" } }}
                                                error={
                                                    formikProps.errors.ikametgahAdresi &&
                                                        formikProps.touched.ikametgahAdresi
                                                        ? true
                                                        : false
                                                }
                                                {...formikProps.getFieldProps("ikametgahAdresi")}
                                                variant="outlined"
                                                disabled
                                            />
                                        </div>
                                        <div className="col-12 col-md-6 d-flex flex-column">
                                            <div style={{ fontSize: "0.85rem", color: "#6c757d", marginBottom: "4px" }}>
                                                Lütfen eklemek istediğiniz bilgileri aşağıdaki alana yazınız.
                                            </div>
                                            <CustomTextField
                                                label="Açıklama *"
                                                rows={5}
                                                fullWidth
                                                multiline
                                                size="small"
                                                InputProps={{ style: { height: "100%" } }}
                                                error={
                                                    formikProps.errors.aciklama &&
                                                        formikProps.touched.aciklama
                                                        ? true
                                                        : false
                                                }
                                                {...formikProps.getFieldProps("aciklama")}
                                            />
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div className="mb-4"><DocumentTable rows={documents} onUpdateDocuments={handleUpdateDocuments} /></div>

                            <div className="d-flex justify-content-end">

                                <Button
                                    type="submit"
                                >
                                    Gönder
                                </Button>
                            </div>

                            {isPopupVisible ? (
                                <BilgilendirmePopup
                                    basvuruTuruId={formikProps.values.basvuruTuruId}
                                    isSorunBildirPopup={!kayitBasarili}
                                    closePopup={closePopupSonuc}
                                    open={isPopupVisible}
                                    editDescription={popupbasvuruMetni}
                                />
                            ) : null}


                        </Form>
                    );
                }}
            </Formik>
    );
};
export default SosyalYardimBasvurusu;
